import { ReactNode, useState } from 'react';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import { SectionTitle } from 'packages/kakapo-ui-kit/components/common/Headings';
import ChevronRightSmallIcon from 'packages/kakapo-ui-kit/assets/icons/ChevronRightSmallIcon';

const AccordionItemElement = styled(Box)`
	background-color: ${(props) => props.theme.colors.white};
	border: 1px solid ${(props) => props.theme.colors.lightBlueLight};
	border-radius: 5px;
`;

const AccordionItemHeader = styled.button<{ isCollapsed: boolean }>`
	background-color: transparent;
	width: 100%;
	text-align: start;

	svg {
		display: block;
		transition: transform 120ms ease-out;
		transform: ${(props) => (!props.isCollapsed ? 'rotate(90deg)' : '')};
		g g {
			fill: ${(props) => props.theme.colors.slateBlue};
		}
	}
`;

export const AccordionItem = ({
	title,
	children,
	initialIsCollaped = true,
}: {
	title: string;
	children: ReactNode;
	initialIsCollaped?: boolean;
}) => {
	const [isCollapsed, setIsCollapsed] = useState<boolean>(initialIsCollaped);

	return (
		<AccordionItemElement mb={3}>
			<AccordionItemHeader
				isCollapsed={isCollapsed}
				onClick={() => {
					setIsCollapsed(!isCollapsed);
				}}
			>
				<Box px={2} py={2}>
					<Flex alignItems="center">
						<Box mr={3}>
							<ChevronRightSmallIcon />
						</Box>
						<SectionTitle>{title}</SectionTitle>
					</Flex>
				</Box>
			</AccordionItemHeader>

			{!isCollapsed && (
				<>
					<Box px={2} pb={2}>
						{children}
					</Box>
				</>
			)}
		</AccordionItemElement>
	);
};

const Accordion = ({ children }: { children: ReactNode }) => {
	return <>{children}</>;
};

export default Accordion;
